import { render, staticRenderFns } from "./ReadinessBadgesStep.vue?vue&type=template&id=378bb901&scoped=true"
import script from "./ReadinessBadgesStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadinessBadgesStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReadinessBadgesStep.vue?vue&type=style&index=0&id=378bb901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378bb901",
  null
  
)

export default component.exports